import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {SurveyComponent} from "./surveyComponent";
import {ResultComponent} from "./resultComponent";
import {BingoRenoHeader} from "./bingoRenoHeader";

export function MainComponent() {
    const [searchParams] = useSearchParams();
    let displayResult = searchParams.get('result');


    return (
        <div className="Main-flex-component">
            <BingoRenoHeader/>
            {displayResult ? <ResultComponent/> : <SurveyComponent/>}
        </div>
    );
}